"use client";
import { type RegisteredComponent } from "@builder.io/sdk-react";

import registerDesignTokens from "./designTokens";
import registerActions from "./customActions";

registerDesignTokens();
registerActions();

import { buttonBlockConfig } from "./blocks/ButtonBlock.builder";
import { codeSnippetBlockConfig } from "./blocks/CodeSnippet.builder";
import { iconBlockConfig } from "./blocks/IconBlock.builder";
import { imageBlockConfig } from "./blocks/ImageBlock.builder";
import { hoverParallaxImageBlockConfig } from "./blocks/HoverParallaxImageBlock.builder";
import { videoBlockConfig } from "./blocks/VideoBlock.builder";
import { sectionBlockConfig } from "./blocks/SectionBlock.builder";
import { linkBlockConfig } from "./blocks/LinkBlock.builder";
import { interactiveBlockConfig } from "./blocks/InteractiveBlock.builder";
import { sliderBlockConfig } from "./blocks/SliderBlock.builder";
import { sliderControlsBlockConfig } from "./blocks/SliderControlsBlock.builder";
import { slidesBlockConfig } from "./blocks/SlidesBlock.builder";
import { horizontalTabBlockConfig } from "./blocks/HorizontalTabBlock.builder";
import { horizontalTabNavigationBlockConfig } from "./blocks/HorizontalTabNavigationBlock.builder";
import { tabPanelsBlockConfig } from "./blocks/TabPanelsBlock.builder";
import { verticalTabBlockConfig } from "./blocks/VerticalTabBlock.builder";
import { stickyNavigationBlockConfig } from "./blocks/StickyNavigationBlock.builder";
import { secondaryNavigationBlockConfig } from "./blocks/SecondaryNavigationBlock.builder";
import { genericTextualInputBlockConfig } from "./blocks/Forms/GenericTextualInputBlock.builder";
import { checkboxInputBlockConfig } from "./blocks/Forms/CheckboxInputBlock.builder";
import { phoneInputBlockConfig } from "./blocks/Forms/PhoneInputBlock.builder";
import { radioInputBlockConfig } from "./blocks/Forms/RadioInputBlock.builder";
import { searchInputBlockConfig } from "./blocks/Forms/SearchInputBlock.builder";
import { selectBlockConfig } from "./blocks/Forms/SelectBlock.builder";
import { AccordionBlockConfig } from "./blocks/Accordion.builder";
import { modalBlockConfig } from "./blocks/ModalBlock.builder";
import { textareaBlockConfig } from "./blocks/Forms/TextareaBlock.builder";
import { hiddenInputBlock } from "./blocks/Forms/HiddenInputBlock.builder";
import { expandableTextBlockConfig } from "./blocks/ExpandableTextBlock.builder";
import { lightboxBlockConfig } from "./blocks/LightboxBlock.builder";
import { closeButtonBlockConfig } from "./blocks/CloseButtonBlock.builder";
import { dialogBlockConfig } from "./blocks/DialogBlock.builder";
import { formConfig } from "./blocks/Forms/FormBlock.builder";
import { spinningBlockConfig } from "./blocks/SpinningBlock.builder";
import { accountStatusMessageBlockConfig } from "./blocks/AccountStatusMessageBlock.builder";
import { donutBlockConfig } from "./blocks/DonutBlock.builder";
import { iconSelectionIdentificatorBlockConfig } from "./blocks/IconSelectionIdentificatorBlock.builder";
import { ExpandableBlockConfig } from "./blocks/ExpandableBlock.builder";
import { dropdownBlockConfig } from "./blocks/DropdownBlock.builder";
import { themeBoxBlockConfig } from "./blocks/ThemeBoxBlock.builder";
import { onPageRailNavigationBlockConfig } from "./blocks/OnPageRailNavigationBlock.builder";
import { tooltipBlockConfig } from "./blocks/TooltipBlock.builder";
import { featuresOverviewBlockConfig } from "./blocks/FeaturesOverviewBlock.builder";
import { featuresOverviewCardsBlockConfig } from "./blocks/FeaturesOverviewCardsBlock.builder";
import { pdfViewerBlockConfig } from "./blocks/PdfViewerBlock.builder";
import { apiWrapperBlockConfig } from "./blocks/ApiWrapperBlock.builder";
import { hushlyEmbedBlockConfig } from "./blocks/HushlyEmbedBlock.builder";
import { iframeEmbedCodeBlockConfig } from "./blocks/IframeEmbedCodeBlock.builder";
import { tableBlockConfig } from "./blocks/Table/TableBlock.builder";
import { tableRowBlockConfig } from "./blocks/Table/TableRowBlock.builder";
import { tableCellBlockConfig } from "./blocks/Table/TableCellBlock.builder";
import { comparisonChartBlockConfig } from "./blocks/ComparisonChartBlock.builder";
import { comparisonChartControlsBlockConfig } from "./blocks/ComparisonChartControlsBlock.builder";
import { contentReplicatorBlockConfig } from "./blocks/ContentReplicatorBlock.builder";
import { globalFooterBlockConfig } from "./blocks/GlobalFooterBlock.builder";
import { chromelessHeaderBlockConfig } from "./blocks/ChromelessHeaderBlock.builder";
import { verticalFilterBlockConfig } from "./blocks/Index/VerticalFilterBlock.builder";
import { indexCardsBlockConfig } from "./blocks/Index/IndexCardsBlock.builder";
import { indexContextBlockConfig } from "./blocks/Index/IndexContextBlock.builder";
import { filterPanelBlockConfig } from "./blocks/Index/FilterPanelBlock.builder";
import { SWDCGlobalSimpleFooterBlockConfig } from "./blocks/SWDCGlobalSimpleFooterBlock.builder";
import { expandableFormBlockConfig } from "./blocks/Forms/ExpandableFormBlock.builder";
import { globalNavigationBlockConfig } from "./blocks/GlobalNavigationBlock.builder";
import { breadcrumbsBlockConfig } from "./blocks/BreadcrumbsBlock.builder";
import { expandableElementBlockConfig } from "./blocks/ExpandableElementBlock.builder";
import { ITGlossaryBlockConfig } from "./blocks/ITGlossaryBlock.builder";
import { subnetCalculatorBlockConfig } from "./blocks/SubnetCalculatorBlock.builder";
import { horizontalFilterConfig } from "./blocks/Index/HorizontalFilterBlock.builder";
import { sortButtonBlockConfig } from "./blocks/Index/SortButtonBlock.builder";
import { filterSearchBlockConfig } from "./blocks/Index/FilterSearchBlock.builder";
import { threadIntegrationBlockConfig } from "./blocks/ThreadIntegrationBlock.builder";
import { cveIndexTableBlockConfig } from "./blocks/Index/CVEIndexBlock.builder";
import { interactiveTableStepsBlockConfig } from "./blocks/InteractiveTableStepsBlock.builder";
import { maturityModelBlockConfig } from "./blocks/MaturityModelBlock.builder";
import { itsmPdfButtonsBlockConfig } from "./blocks/ItsmPdfButtonsBlock.builder";
import { itsmWrapperBlockConfig } from "./blocks/ItsmWrapperBlock.builder";
import { internalSearchResultsBlockConfig } from "./blocks/InternalSearch/InternalSearchResultsBlock.builder";
import { swdcInternalSearchLeftFilterBlockConfig } from "./blocks/InternalSearch/SWDCInternalSearchLeftFilterBlock.builder";
import { swdcInternalSearchTopFilterBlockConfig } from "./blocks/InternalSearch/SWDCInternalSearchTopFilterBlock.builder";
import { swdcInternalSearchWrapperBlockConfig } from "./blocks/InternalSearch/SWDCInternalSearchWrapperBlock.builder";
import { cscInternalSearchContextBlockConfig } from "./blocks/InternalSearch/CscInternalSearchContextBlock.builder";
import { internalSearchBannerBlockConfig } from "./blocks/InternalSearch/InternalSearchBannerBlock.builder";
import { trustBadgeBlockConfig } from "./blocks/TrustBadgeBlock.builder";
import { g2RatingBlockConfig } from "./blocks/G2RatingBlock.builder";
import { evolutionTabNavigationBlockConfig } from "./blocks/EvolutionTabNavigationBlock.builder";
import { categoryTabNavigationBlockConfig } from "./blocks/CategoryTabNavigationBlock.builder";
import { ThemeBoxBlock } from "./blocks/ThemeBoxBlock";
import { ButtonBlock } from "./blocks/ButtonBlock";
import { CodeSnippetBlock } from "./blocks/CodeSnippetBlock";
import { IconBlock } from "./blocks/IconBlock";
import { ImageBlock } from "./blocks/ImageBlock";
import { HoverParallaxImageBlock } from "./blocks/HoverParallaxImageBlock";
import { VideoBlock } from "./blocks/VideoBlock";
import { SectionBlock } from "./blocks/SectionBlock";
import { LinkBlock } from "./blocks/LinkBlock";
import { InteractiveBlock } from "./blocks/InteractiveBlock";
import { SliderBlock } from "./blocks/SliderBlock";
import { HorizontalTabBlock } from "./blocks/HorizontalTabBlock";
import { HorizontalTabNavigationBlock } from "./blocks/HorizontalTabNavigationBlock";
import { TabPanelsBlock } from "./blocks/TabPanelsBlock";
import { VerticalTabBlock } from "./blocks/VerticalTabBlock";
import { StickyNavigationBlock } from "./blocks/StickyNavigationBlock";
import { AccordionBlock } from "./blocks/AccordionBlock";
import { FeaturesOverviewBlock } from "./blocks/FeaturesOverviewBlock";
import { FeaturesOverviewCardsBlock } from "./blocks/FeaturesOverviewCardsBlock";
import { SecondaryNavigationBlock } from "./blocks/SecondaryNavigationBlock";
import { GenericTextualInputBlock } from "./blocks/Forms/GenericTextualInputBlock";
import { PhoneInputBlock } from "./blocks/Forms/PhoneInputBlock";
import { CheckboxInputBlock } from "./blocks/Forms/CheckboxInputBlock";
import { RadioInputBlock } from "./blocks/Forms/RadioInputBlock";
import { SearchInputBlock } from "./blocks/Forms/SearchInputBlock";
import { SelectBlock } from "./blocks/Forms/SelectBlock";
import { ModalBlock } from "./blocks/ModalBlock";
import { TextareaBlock } from "./blocks/Forms/TextareaBlock";
import { HiddenInputBlock } from "./blocks/Forms/HiddenInputBlock";
import { ExpandableTextBlock } from "./blocks/ExpandableTextBlock";
import { CloseButtonBlock } from "./blocks/CloseButtonBlock";
import { DialogBlock } from "./blocks/DialogBlock";
import { FormBlock } from "./blocks/Forms/FormBlock";
import { SpinningBlock } from "./blocks/SpinningBlock";
import { AccountStatusMessageBlock } from "./blocks/AccountStatusMessageBlock";
import { ExpandableBlockBlock } from "./blocks/ExpandableBlockBlock";
import { DropdownBlock } from "./blocks/DropdownBlock";
import { OnPageRailNavigationBlock } from "./blocks/OnPageRailNavigationBlock";
import { TooltipBlock } from "./blocks/TooltipBlock";
import { PdfViewerBlock } from "./blocks/PdfViewerBlock";
import { ApiWrapperBlock } from "./blocks/ApiWrapperBlock";
import { HushlyEmbedBlock } from "./blocks/HushlyEmbedBlock";
import { IframeEmbedCodeBlock } from "./blocks/IframeEmbedCodeBlock";
import { TableBlock } from "./blocks/Table/TableBlock";
import { TableRowBlock } from "./blocks/Table/TableRowBlock";
import { TableCellBlock } from "./blocks/Table/TableCellBlock";
import { ComparisonChartBlock } from "./blocks/ComparisonChartBlock";
import { ComparisonChartControlsBlock } from "./blocks/ComparisonChartControlsBlock";
import { ContentReplicatorBlock } from "./blocks/ContentReplicatorBlock";
import { GlobalFooterBlock } from "./blocks/GlobalFooterBlock";
import { ChromelessHeaderBlock } from "./blocks/ChromelessHeaderBlock";
import { VerticalFilterBlock } from "./blocks/Index/VerticalFilterBlock";
import { FilterPanelBlock } from "./blocks/Index/FilterPanelBlock";
import { IndexCardsBlock } from "./blocks/Index/IndexCardsBlock";
import { IndexCardsContextBlock } from "./blocks/Index/IndexContextBlock";
import { SWDCGlobalSimpleFooterBlock } from "./blocks/SWDCGlobalSimpleFooterBlock";
import { ExpandableFormBlock } from "./blocks/Forms/ExpandableFormBlock";
import { GlobalNavigationBlock } from "./blocks/GlobalNavigationBlock";
import { BreadcrumbsBlock } from "./blocks/BreadcrumbsBlock";
import { ExpandableElementBlock } from "./blocks/ExpandableElementBlock";
import { ITGlossaryBlock } from "./blocks/ITGlossaryBlock";
import { SubnetCalculatorBlock } from "./blocks/SubnetCalculatorBlock";
import { HorizontalFilterBlock } from "./blocks/Index/HorizontalFilterBlock";
import { SortButtonBlock } from "./blocks/Index/SortButtonBlock";
import { FilterSearchBlock } from "./blocks/Index/FilterSearchBlock";
import { ThreadIntegrationBlock } from "./blocks/ThreadIntegrationBlock";
import { CVEIndexBlock } from "./blocks/Index/CVEIndexBlock";
import InteractiveTableStepsBlock from "./blocks/InteractiveTableStepsBlock";
import { MaturityModelBlock } from "./blocks/MaturityModelBlock";
import { ItsmPdfButtonsBlock } from "./blocks/ItsmPdfButtonsBlock";
import { ItsmWrapperBlock } from "./blocks/ItsmWrapperBlock";
import { InternalSearchResultsBlock } from "./blocks/InternalSearch/InternalSearchResultsBlock";
import { SWDCInternalSearchLeftFilterBlock } from "./blocks/InternalSearch/SWDCInternalSearchLeftFilterBlock";
import { SWDCInternalSearchTopFilterBlock } from "./blocks/InternalSearch/SWDCInternalSearchTopFilterBlock";
import { SWDCInternalSearchWrapperBlock } from "./blocks/InternalSearch/SWDCInternalSearchWrapperBlock";
import { CscInternalSearchContextBlock } from "./blocks/InternalSearch/CscInternalSearchContextBlock";
import { InternalSearchBannerBlock } from "./blocks/InternalSearch/InternalSearchBannerBlock";
import { TrustBadgeBlock } from "./blocks/TrustBadgeBlock";
import { G2RatingBlock } from "./blocks/G2RatingBlock";
import { EvolutionTabNavigationBlock } from "./blocks/EvolutionTabNavigationBlock";
import { CategoryTabNavigationBlock } from "./blocks/CategoryTabNavigationBlock";
import dynamic from "next/dynamic";
import { IconSelectionIdentificatorBlock } from "./blocks/IconSelectionIdentificatorBlock";
import { LottieBlock } from "./blocks/LottieBlock";
import { lottieBlockConfig } from "./blocks/LottieBlock.builder";
import { PersonalizationContainer } from "./blocks/PersonalizationContainer";
import { personalizationContainerConfig } from "./blocks/PersonalizationContainer.builder";
import { navatticBlockConfig } from "./blocks/NavatticBlock.builder";
import { NavatticBlock } from "./blocks/NavatticBlock";

export const customComponents: RegisteredComponent[] = [
  {
    component: ThemeBoxBlock,
    ...themeBoxBlockConfig,
  },
  {
    component: ButtonBlock,
    ...buttonBlockConfig,
  },
  {
    component: CodeSnippetBlock,
    ...codeSnippetBlockConfig,
  },
  {
    component: IconBlock,
    ...iconBlockConfig,
  },
  {
    component: ImageBlock,
    ...imageBlockConfig,
  },
  {
    component: HoverParallaxImageBlock,
    ...hoverParallaxImageBlockConfig,
  },
  {
    component: VideoBlock,
    ...videoBlockConfig,
  },
  {
    component: SectionBlock,
    ...sectionBlockConfig,
  },
  {
    component: LinkBlock,
    ...linkBlockConfig,
  },
  {
    component: InteractiveBlock,
    ...interactiveBlockConfig,
  },
  {
    component: SliderBlock,
    ...sliderBlockConfig,
  },
  {
    component: dynamic(() =>
      import("./blocks/SliderControlsBlock").then(
        (mod) => mod.SliderControlBlocks,
      ),
    ),
    ...sliderControlsBlockConfig,
  },
  {
    component: dynamic(() =>
      import("./blocks/SlidesBlock").then((mod) => mod.SlidesBlock),
    ),
    ...slidesBlockConfig,
  },
  {
    component: HorizontalTabBlock,
    ...horizontalTabBlockConfig,
  },
  {
    component: HorizontalTabNavigationBlock,
    ...horizontalTabNavigationBlockConfig,
  },
  {
    component: TabPanelsBlock,
    ...tabPanelsBlockConfig,
  },
  {
    component: VerticalTabBlock,
    ...verticalTabBlockConfig,
  },
  {
    component: StickyNavigationBlock,
    ...stickyNavigationBlockConfig,
  },
  {
    component: AccordionBlock,
    ...AccordionBlockConfig,
  },
  {
    component: FeaturesOverviewBlock,
    ...featuresOverviewBlockConfig,
  },
  {
    component: FeaturesOverviewCardsBlock,
    ...featuresOverviewCardsBlockConfig,
  },
  {
    component: SecondaryNavigationBlock,
    ...secondaryNavigationBlockConfig,
  },
  {
    component: GenericTextualInputBlock,
    ...genericTextualInputBlockConfig,
  },
  {
    component: PhoneInputBlock,
    ...phoneInputBlockConfig,
  },
  {
    component: CheckboxInputBlock,
    ...checkboxInputBlockConfig,
  },
  {
    component: RadioInputBlock,
    ...radioInputBlockConfig,
  },
  {
    component: SearchInputBlock,
    ...searchInputBlockConfig,
  },
  {
    component: SelectBlock,
    ...selectBlockConfig,
  },
  {
    component: ModalBlock,
    ...modalBlockConfig,
  },
  {
    component: TextareaBlock,
    ...textareaBlockConfig,
  },
  {
    component: HiddenInputBlock,
    ...hiddenInputBlock,
  },
  {
    component: ExpandableTextBlock,
    ...expandableTextBlockConfig,
  },
  {
    component: dynamic(() =>
      import("./blocks/LightboxBlock").then((mod) => mod.LightboxBlock),
    ),
    ...lightboxBlockConfig,
  },
  {
    component: CloseButtonBlock,
    ...closeButtonBlockConfig,
  },
  {
    component: DialogBlock,
    ...dialogBlockConfig,
  },
  {
    component: FormBlock,
    ...formConfig,
  },
  {
    component: SpinningBlock,
    ...spinningBlockConfig,
  },
  {
    component: AccountStatusMessageBlock,
    ...accountStatusMessageBlockConfig,
  },
  {
    component: dynamic(() =>
      import("./blocks/DonutBlock").then((mod) => mod.DonutBlock),
    ),
    ...donutBlockConfig,
  },
  {
    component: ExpandableBlockBlock,
    ...ExpandableBlockConfig,
  },
  {
    component: DropdownBlock,
    ...dropdownBlockConfig,
  },
  {
    component: OnPageRailNavigationBlock,
    ...onPageRailNavigationBlockConfig,
  },
  {
    component: TooltipBlock,
    ...tooltipBlockConfig,
  },
  {
    component: PdfViewerBlock,
    ...pdfViewerBlockConfig,
  },
  {
    component: ApiWrapperBlock,
    ...apiWrapperBlockConfig,
  },
  {
    component: HushlyEmbedBlock,
    ...hushlyEmbedBlockConfig,
  },
  {
    component: IframeEmbedCodeBlock,
    ...iframeEmbedCodeBlockConfig,
  },
  {
    component: TableBlock,
    ...tableBlockConfig,
  },
  {
    component: TableRowBlock,
    ...tableRowBlockConfig,
  },
  {
    component: TableCellBlock,
    ...tableCellBlockConfig,
  },
  {
    component: ComparisonChartBlock,
    ...comparisonChartBlockConfig,
  },
  {
    component: ComparisonChartControlsBlock,
    ...comparisonChartControlsBlockConfig,
  },
  {
    component: ContentReplicatorBlock,
    ...contentReplicatorBlockConfig,
  },
  {
    component: GlobalFooterBlock,
    ...globalFooterBlockConfig,
  },
  {
    component: ChromelessHeaderBlock,
    ...chromelessHeaderBlockConfig,
  },
  {
    component: VerticalFilterBlock,
    ...verticalFilterBlockConfig,
  },
  {
    component: FilterPanelBlock,
    ...filterPanelBlockConfig,
  },
  {
    component: IndexCardsBlock,
    ...indexCardsBlockConfig,
  },
  {
    component: IndexCardsContextBlock,
    ...indexContextBlockConfig,
  },
  {
    component: SWDCGlobalSimpleFooterBlock,
    ...SWDCGlobalSimpleFooterBlockConfig,
  },
  {
    component: ExpandableFormBlock,
    ...expandableFormBlockConfig,
  },
  {
    component: GlobalNavigationBlock,
    ...globalNavigationBlockConfig,
  },
  {
    component: BreadcrumbsBlock,
    ...breadcrumbsBlockConfig,
  },
  {
    component: ExpandableElementBlock,
    ...expandableElementBlockConfig,
  },
  {
    component: ITGlossaryBlock,
    ...ITGlossaryBlockConfig,
  },
  {
    component: SubnetCalculatorBlock,
    ...subnetCalculatorBlockConfig,
  },
  {
    component: HorizontalFilterBlock,
    ...horizontalFilterConfig,
  },
  {
    component: SortButtonBlock,
    ...sortButtonBlockConfig,
  },
  {
    component: FilterSearchBlock,
    ...filterSearchBlockConfig,
  },
  {
    component: ThreadIntegrationBlock,
    ...threadIntegrationBlockConfig,
  },
  {
    component: CVEIndexBlock,
    ...cveIndexTableBlockConfig,
  },
  {
    component: InteractiveTableStepsBlock,
    ...interactiveTableStepsBlockConfig,
  },
  {
    component: MaturityModelBlock,
    ...maturityModelBlockConfig,
  },
  {
    component: ItsmPdfButtonsBlock,
    ...itsmPdfButtonsBlockConfig,
  },
  {
    component: ItsmWrapperBlock,
    ...itsmWrapperBlockConfig,
  },
  {
    component: InternalSearchResultsBlock,
    ...internalSearchResultsBlockConfig,
  },
  {
    component: SWDCInternalSearchLeftFilterBlock,
    ...swdcInternalSearchLeftFilterBlockConfig,
  },
  {
    component: SWDCInternalSearchTopFilterBlock,
    ...swdcInternalSearchTopFilterBlockConfig,
  },
  {
    component: SWDCInternalSearchWrapperBlock,
    ...swdcInternalSearchWrapperBlockConfig,
  },
  {
    component: CscInternalSearchContextBlock,
    ...cscInternalSearchContextBlockConfig,
  },
  {
    component: InternalSearchBannerBlock,
    ...internalSearchBannerBlockConfig,
  },
  {
    component: TrustBadgeBlock,
    ...trustBadgeBlockConfig,
  },
  {
    component: G2RatingBlock,
    ...g2RatingBlockConfig,
  },
  {
    component: EvolutionTabNavigationBlock,
    ...evolutionTabNavigationBlockConfig,
  },
  {
    component: IconSelectionIdentificatorBlock,
    ...iconSelectionIdentificatorBlockConfig,
  },
  {
    component: CategoryTabNavigationBlock,
    ...categoryTabNavigationBlockConfig,
  },
  {
    component: LottieBlock,
    ...lottieBlockConfig,
  },
  {
    component: PersonalizationContainer,
    ...personalizationContainerConfig,
  },
  { component: NavatticBlock, ...navatticBlockConfig },
];
